import gql from 'graphql-tag';

export const companyFragment = gql`
  fragment companyAll on Company {
    address
    allowedToMassSend
    messageLimitExceeded
    activeSubscription {
      billingPeriod
      incomplete
      plan
      planType
      stripeStatus
      collectionMethod
      boostable
    }
    billingInfo {
      hasDispute
      hasOutstandingInvoice
      dontHaveVatNumber
      stripeTaxId {
        value
        verification
      }
    }
    blocked
    blockReason
    companyType
    contactEmail
    contactEmailVerified
    city
    collectivePayment
    companyType
    country
    currency
    dac7Details {
      country
      legalForm
      businessRegistrationNumber
      taxIdentificationNumber
      vatNumber
    }
    facebookId
    fullAddress
    franchiseId
    freeEmployees
    fromWavy
    giftcardPersonalMessage
    hasReferrer
    id
    instagramId
    internalName
    language
    languagePublic
    locale {
      clock
      countryCode
      defaultCurrency
      defaultLanguage
      eu
      firstDayOfWeek
      radix
      sepa
    }
    logo {
      small
      thumbnail
      large
    }
    marketingTrialEndsAt
    medical
    prolightMarket
    name
    nameWasChanged
    notificationEmail
    ownerUser {
      id
      firstName
      lastName
    }
    paymentGatewayStatus
    paymentGatewayProvider {
      key
      state
    }
    phone
    postalcode
    primaryLocationId
    publicId
    stockWarnings
    treatwellSales
    unleashContextProperties
    contactEmailVerified
    firstPaymentPending
    settings {
      agenda {
        allowCancellations
        allowRescheduling
        appointmentEndBuffer
        appointmentEndBufferTime
        appointmentInterval
        cancellationHours
        colour
        darkerColors
        endTime
        hideClosedResources
        reschedulingHours
        slotInterval
        startTime
      }
      betaPages {
        calendar
        marketing
        products
        register
        reports
      }
      bookings {
        appointmentRequiresConfirmation
        appointmentRequestNewCustomers
        appointmentRequestDurationMinimum
        appointmentRequestDurationMinimumValue
        appointmentRequestPriceMinimum
        appointmentRequestPriceMinimumValue
        addressFields
        allowMultipleServices
        allowNewCustomers
        categoriesCollapsible
        customAlert
        customCustomerStopMessage
        customCssEnabled
        dateOfBirth
        dynamicPricingEnabled
        employeeSelectionFirst
        employeeSelectionPerService
        giftcardPaymentsAllowed
        lastMinuteDiscountEnabled
        lastMinuteDiscountPercentage
        lastMinuteDiscountWindow
        leadTime
        maxTimeInAdvance
        onlinePayment
        onlinePaymentAll
        onlinePaymentCharge
        onlinePaymentDepositAmount
        onlinePaymentDepositType
        onlinePaymentMinimumDuration
        onlinePaymentMinimumDurationValue
        onlinePaymentMinimumPrice
        onlinePaymentMinimumPriceValue
        onlinePaymentPercentage
        onlinePaymentTipping
        onlyExistingCustomersResourceIds
        paymentFailedUrl
        paymentSuccessUrl
        prepaymentsForNewCustomersOnly
        preventGaps
        rebookReminderEnabled
        requiresCountry
        resourceSelection
        showCustomAlert
        showNewsletterOptin
        showScrollArrow
        showServiceDuration
        showServicePrices
        smsNotification
        stripeIdeal
        privacyStatementUrl
        termsConditionsUrl
        topServicesIds
        topServicesEnabled
        waitingListEnabled
        useEmployeeSortOrderForAvailability
      }
      bookingWidget {
        allowMonthView
        appointmentOverviewRequest
        autoWidth
        buttonSize
        customColor
        height
        inline
        outline
        position
        primaryColor
        width
      }
      communication {
        appointmentConfirmation
        appointmentNoShow
        onlineFormSubmissions
      }
      customers {
        appointmentFeedback
        appointmentFeedbackDelay
        birthdayMessageEnabled
        custom10Label
        custom1Label
        custom2Label
        custom3Label
        custom4Label
        custom5Label
        custom6Label
        custom7Label
        custom8Label
        custom9Label
        feedbackGoogleReview
        iplEnabled
        sendOnlineForms
      }
      features {
        medical
      }
      general {
        allowImpersonation
        boughtTerminalFromSubscriptionFlow
        ipRestrictions
        marketingTrialRequested
        reactivatedAt
        registerNewDesign
        treatwellTrialRequested
        salonizedPayInterest
      }
      locale {
        clock
        firstDayOfWeek
      }
      sales {
        giftcardCustomAmount
        giftcardCustomAmountMax
        giftcardCustomAmountMin
        giftcardExpiration
        giftcardExpirationValue
        giftcardPersonalMessage
        giftcardPicture
        giftcardValues
        loyaltyPointsAmount
        loyaltyPointsType
        paymentLink
        thermalSupport
        showTreatmentDateOnInvoice
        generateInvoiceAutomatically
        invoiceDueDateInDays
        allowedPaymentMethods
      }
      store {
        interestedAt
        lastVisitedProductsAreaAt
      }
      onlineRoutes {
        lastVisitedAt
        websiteServiceInterestedAt
      }
      treatwell {
        automaticallyPushFeedback
        interestedAt
        interestedSource
        notInterestedAt
      }
      fiscalization {
        tssId
      }
      onboarding {
        customerFirstName
        customerLastName
        serviceDuration
        serviceName
        servicePrice
        serviceCategoryName
        employeeName
        flowStep
      }
      reminders {
        emailReminderEnabled
        emailReminderHours
        smsReminderEnabled
        smsReminderHours
      }
      abTesting {
        flags
      }
    }
    smsCreditPricing
    smsCredits
    smsNotificationNumber
    smsSenderId
    subscribed
    termsAcceptedAt
    timeZoneName
    treatwellSales
    trialEndAt
    twitterId
    toBeBlockedAt
    treatwellVenue {
      ddEnabledDate
      description
      id
    }
  }
`;
